
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class RowCustomizationDialog extends SiteEntityDialog<RowCustomizationRow, any> {
        protected getFormKey() { return RowCustomizationForm.formKey; }
        protected getIdProperty() { return RowCustomizationRow.idProperty; }
        protected getLocalTextPrefix() { return RowCustomizationRow.localTextPrefix; }
        protected getNameProperty() { return RowCustomizationRow.nameProperty; }
        protected getService() { return RowCustomizationService.baseUrl; }

        protected form = new RowCustomizationForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            this.form.FieldCustomizations.element.css('height', Math.max(150, $(window).height() - 190) + 'px').trigger('layout');
        }

        afterLoadEntity() {
            super.afterLoadEntity();

            this.form.FieldCustomizations.rowCode = this.entity.RowCode;
        }
    }
}